"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Complex {
  constructor(real, imaginary) {
    this.real = real;
    this.imaginary = imaginary;
  }
  static createComplex(real, imaginary) {
    return new Complex(real, imaginary);
  }
  complexfreq(fp) {
    var complexfreq = new Array();
    for (var r = 0; r < fp.length; r++) {
      complexfreq[r] = new Complex(fp[r], 0);
    }
    return complexfreq;
  }
  complexNumberRaisedToPower(c, n) {
    var modC, theta, retComplex, realPart, imaginaryPart;

    // |x+iy| = Math.sqrt(x^2 + y^2) = |z|
    modC = Math.sqrt(c.real * c.real + c.imaginary * c.imaginary);

    // |x+iy|^n  = |z|^n
    var modCpowern = Math.pow(modC, n);

    //theta=tan^(-1)(y/x)>
    theta = Math.atan2(c.imaginary, c.real);

    //|z|^n * cos(n* theta)
    realPart = modCpowern * Math.cos(n * theta);

    //|z|^n * sin(n* theta)
    imaginaryPart = modCpowern * Math.sin(n * theta);

    //zn = rn(cos(ntheta)+i sin(ntheta))
    retComplex = new Complex(realPart, imaginaryPart);
    return retComplex;
  }
  toString() {
    return this.real + " + " + this.imaginary + "i";
  }
  plus(c) {
    return new Complex(this.real + c.real, this.imaginary + c.imaginary);
  }
  plusDestroy(c) {
    var realPart = c.real;
    var imagPart = c.imaginary;
    c.real = this.real + realPart;
    c.imaginary = this.imaginary + imagPart;
    return c;
  }
  subs(c) {
    return new Complex(this.real - c.real, this.imaginary - c.imaginary);
  }
  subsDestroy(c) {
    var realPart = c.real;
    var imagPart = c.imaginary;
    c.real = this.real - realPart;
    c.imaginary = this.imaginary - imagPart;
    return c;
  }
  mult(c) {
    var realPart = c.real;
    var imagPart = c.imaginary;
    return new Complex(realPart * this.real - imagPart * this.imaginary, this.imaginary * realPart + imagPart * this.real);
  }
  multDestroy(c) {
    var realPart = c.real;
    var imagPart = c.imaginary;
    c.real = realPart * this.real - imagPart * this.imaginary;
    c.imaginary = this.imaginary * realPart + imagPart * this.real;
    return c;
  }
  divide(c) {
    var realPart = c.real;
    var imagPart = c.imaginary;
    var divident = realPart * realPart + imagPart * imagPart;
    return new Complex((this.real * realPart + this.imaginary * imagPart) / divident, (this.imaginary * realPart - this.real * imagPart) / divident);
  }
  divideDestroy(c) {
    var realPart = c.real;
    var imagPart = c.imaginary;
    var divident = realPart * realPart + imagPart * imagPart;
    c.real = (this.real * realPart + this.imaginary * imagPart) / divident;
    c.imaginary = (this.imaginary * realPart - this.real * imagPart) / divident;
    return c;
  }
  magnitude() {
    return Math.sqrt(this.real * this.real + this.imaginary * this.imaginary);
  }
  arctan(c) {
    var i = Complex.I;
    return i.mult(Complex.log(i.plus(c).divide(i.subs(c)))).divide(new Complex(2, 0, 2, 0));
  }
  floor(c) {
    return new Complex(Math.floor(c.real), Math.floor(c.imaginary));
  }
  log(c) {
    return new Complex(Math.log(c.real), c.t + 2 * Math.PI * Math.floor(-c.t / (2 * Math.PI) + 1 / 2));
  }
}
exports.default = Complex;